module.exports = __webpack_public_path__ + "img/public_institution.5ddba6ce.jpg";